const Home = () => import('Views/home/home-new-ui');
const OldHome = () => import('Views/home/home');
const Ship = () => import('Views/home/ship');
const Drilling = () => import('Views/home/drilling');
const Satellite = () => import('Views/home/satellite');

export default[
  { path: '/', name: '/', component: Home },
  { path: '/home', component: Home },
  { path: '/old-home', component: OldHome },
  { path: '/ship', component: Ship },
  { path: '/drilling', component: Drilling },
  { path: '/satellite', component: Satellite },
];



// WEBPACK FOOTER //
// ./src/router/home.js